<template>
  <FormDocument type="Facture" api-type="invoices" />
</template>

<script>
import FormDocument from '@/components/Form/Document'
export default {
  components: {
    FormDocument,
  },
  theme() {
    return {
      title: 'Ajouter une facture',
      subtitle: '',
    }
  },
}
</script>

<style></style>
